import { Col, Row, Select, Tooltip } from "antd";
// import "antd/dist/reset.css";
// import { Card } from "@material-ui/core";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Card } from "@material-ui/core";
import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogActions, DialogContent, DialogTitle, Grow, IconButton, Alert as MuiAlert, Snackbar, ToggleButton, ToggleButtonGroup, useMediaQuery, useTheme } from "@mui/material";
import { t } from "i18next";
import React, { useContext, useEffect, useState } from "react";
import { configUrl } from "../config";
import { LoginContext } from "../contexts/LoginContext";
import { addJEERank } from "../services/addJeeRank";
import { addCetRank } from "../services/CollegePredictorServices/addCetRank";
import { getPredictedColleges } from "../services/CollegePredictorServices/aiCollegePredictorService";
import { getCollegeByCode } from "../services/CollegePredictorServices/collegeFilterService";
import { getCollegesByPercentile, getCollegesByRank } from "../services/CollegePredictorServices/rankRangeFilterService";
import '../styles/CollegePredictor.css';
import WarningCustomModal from "./CustomModal/WarningCustomModal";
import LegendInfo from "./LegendInfo";

// /CollegePredictor.css";
const { Option } = Select;

const CollegePredictors = ({ predictor, handleBack }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const { UserId, userDetail, setUserDetail } = useContext(LoginContext);
    const [predictorType, setpredictorType] = useState(predictor);
    const [startPercentile, setStartPercentile] = useState(null);
    const [endPercentile, setEndPercentile] = useState(null);
    const [startRank, setStartRank] = useState(null);
    const [mhtcetRank, setMhtcetRank] = useState(predictor === "jee" ? userDetail?.jeeRank : userDetail?.mhtcetRank);
    const [ConfirmMhtcetRank, setConfirmMhtcetRank] = useState(predictor === "jee" ? userDetail?.jeeRank : userDetail?.mhtcetRank);
    const [endRank, setEndRank] = useState(null);
    const [branches, setBranches] = useState([]);
    const [category, setCategory] = useState(predictorType == "jee" ? "JEE" : "All");
    const [quotaValue, setQuotaValue] = useState("All");
    const [typeValue, setTypeValue] = useState("All");
    const [city, setCity] = useState([]);
    const [colleges, setColleges] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showNoDataMsg, setShowNoDataMsg] = useState(false);
    const [open, setOpen] = useState(false);
    const [showError, setShowError] = useState([]);
    const [branchOptions, setBranchOptions] = useState([]);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [typeOptions, setTypeOptions] = useState([
        {
            "code": "All",
            "name": "All"
        },
        {
            "code": "general",
            "name": "General",
        },
        {
            "code": "ladies",
            "name": "Ladies",
        }
    ]);
    const [quotaOptions, setQuotaOptions] = useState([
        {
            "code": "All",
            "name": "All",
        },
        {
            "code": "H",
            "name": "Home University",
        },
        {
            "code": "O",
            "name": "Other than Home University",
        },
        {
            "code": "S",
            "name": "State Level",
        }
    ]);

    const [collegesOptions, setCollegesOptions] = useState([])
    const [cityOptions, setCityOptions] = useState([]);
    const [clickedCollege, setClickedCollege] = useState(null);
    const [errors, setErrors] = useState({});
    const [collegeCode, setCollegeCode] = useState(null);
    const [collegeName, setCollegeName] = useState(null);
    const [showLegendModel, setShowLegendModel] = useState(false);
    const [showRankConfgModal, setShowRankConfgModal] = useState(false);
    const [initialWarning, setInitialWarning] = useState(false);

    const [isTggleOpen, setIsToggleOpen] = useState('percentileRange')
    console.log("mhtc terak", mhtcetRank, "  ", userDetail);

    useEffect(() => {
        if (isTggleOpen === 'AIPredictor' && (predictor == "jee" ? userDetail.jeeRank === null : userDetail.mhtcetRank === null)) {
            setInitialWarning(true);
        } else {
            setInitialWarning(false);
        }
    }, [isTggleOpen])
    useEffect(() => {
        const fetchFilters = async () => {
            try {
                const response = await fetch(`${configUrl.PredictorServer}/filters/${predictorType}`);
                const data = await response.json();
                const uniqueBranches = Array.from(new Set(data?.branches || []));
                setBranchOptions(uniqueBranches);
                if (predictorType == "jee") {
                    setCategoryOptions(["JEE", "NEET", "MHT-CET", "MHT-CET-PCM", "MHT-CET-PCB"]);
                } else {
                    setCategoryOptions(data?.categories);
                }
                setCityOptions(data?.cities);
                const collegeList = Object.entries(data?.collegesWithCodes)
                    ?.map(([code, name]) => ({
                        code,
                        name,
                    }))
                    ?.sort((a, b) => a.name.localeCompare(b.name));

                setCollegesOptions(collegeList);
            } catch (error) {
                console.error("Error fetching filter options:", error);
            }
        };
        fetchFilters();
    }, []);

    const validatePercentileInputs = () => {
        let errors = {};
        const messages = [];

        if (startPercentile <= 0) {
            errors.startPercentile = "Start Percentile should be greater than zero!";
            messages.push('Start Percentile should be greater than zero!')
            // setOpen(true);
        }

        if (endPercentile <= 0) {
            errors.endPercentile = "End Percentile should be greater than zero!";
            messages.push('End Percentile should be greater than zero!')
            // setOpen(true);
        }

        if (startPercentile > 100) {
            errors.startPercentile = "Start Percentile should not be greater than 100!";
            messages.push('Start Percentile should not be greater than 100!')
            // setOpen(true);
        }
        if (endPercentile > 100) {
            errors.endPercentile = "End Percentile should should not be greater than 100!";
            messages.push('End Percentile should should not be greater than 100!')

            // setOpen(true);
        }
        if (endPercentile <= startPercentile) {
            errors.endPercentile = "End Percentile should be greater than Start Percentile!";
            messages.push('End Percentile should be greater than Start Percentile!')
            // setOpen(true);
        }
        if (endPercentile - startPercentile > 5) {
            errors.endPercentile = "Percentile difference shouldn't exceed 5!";
            messages.push("Percentile difference shouldn't exceed 5!")
            // setOpen(true);
        }

        if (city.length > 3) {
            errors.city = "You can select a maximum of 3 cities!";
            messages.push('You can select a maximum of 3 cities!')
            // setOpen(true);
        }

        if (messages.length) {
            setShowError(messages);
            setOpen(true);           // show the Snackbar once
            return false;
        }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const validateInputs = () => {
        let errors = {};
        const messages = [];

        if (startRank <= 0) {
            errors.startRank = "Start Rank should be greater than zero!";
            messages.push('Start Rank should be greater than zero!')
        }

        if (endRank <= 0) {
            errors.endRank = "End Rank should be greater than zero!";
            messages.push('End Rank should be greater than zero!');
        }

        if (endRank <= startRank) {
            errors.endRank = "End Rank should be greater than Start Rank!";
            messages.push('End Rank should be greater than Start Rank!');
        }
        if (endRank - startRank > 5000) {
            errors.endRank = "Rank difference shouldn't exceed 5000!";
            messages.push("Rank difference shouldn't exceed 5000!")
        }

        if (city.length > 3) {
            errors.city = "You can select a maximum of 3 cities!";
            messages.push('You can select a maximum of 3 cities!')
        }
        if (messages.length) {
            setShowError(messages);     // ONE call
            setOpen(true);           // show the Snackbar once
            return false;
        }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const validateInputsforCollgeBased = () => {
        let errors = {};
        const messages = []
        if ((collegeCode === null || collegeCode === 0)) {
            errors.collegeName = "College Code or Name is required!";
            errors.collegeCode = "College Code or Name is required!";
            messages.push("College Code or Name is required!")
        }
        else if (collegeName === null) {
            errors.collegeCode = "Invalid college code";
            messages.push('Invalid college code')
        }
        if (isTggleOpen === 'collegeSpecific' && category === "All") {
            errors.category = "Please select one category.";
            messages.push('Please select one category.');
        }
        if (messages.length) {
            setShowError(messages);
            setOpen(true);           // show the Snackbar once
            return false;
        }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const validateInputsForAiBased = () => {
        let errors = {};
        const messages = []
        if (mhtcetRank === null || mhtcetRank <= 0) {
            errors.mhtcetRank = "Please add your rank.";
            messages.push("Please add your rank.")
        }

        if (city.length > 3) {
            errors.city = "You can select a maximum of 3 cities!";
            messages.push('You can select a maximum of 3 cities!')
        }
        if (messages.length) {
            setShowError(messages);
            setOpen(true);           // show the Snackbar once
            return false;
        }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const fetchCollegesByPercentile = async () => {

        if (!validatePercentileInputs()) return;

        setLoading(true);
        setShowNoDataMsg(true);
        let collData = {
            start_Percentile: startPercentile,
            end_Percentile: endPercentile,
            branches: branches.length > 0 ? branches : ["All"],
            category,
            city: city.length > 0 ? city : ["All"],
        }
        console.log('passing Values of fetchCollegesSpecific', collData);

        try {
            let data = await getCollegesByPercentile(predictorType, startPercentile, endPercentile, collData.branches, category, collData.city, typeValue, quotaValue);
            setColleges(data || []);
        } catch (error) {
            console.error("Error fetching colleges:", error);
        }
        setLoading(false);
    };

    const fetchColleges = async () => {

        if (!validateInputs()) return;

        setLoading(true);
        setShowNoDataMsg(true);
        let collData = {
            start_rank: startRank,
            end_rank: endRank,
            branches: branches.length > 0 ? branches : ["All"],
            category,
            city: city.length > 0 ? city : ["All"],
        }
        console.log('passing Values of fetchCollegesSpecific', collData);

        try {
            let data = await getCollegesByRank(predictorType, startRank, endRank, collData.branches, category, collData.city, typeValue, quotaValue);
            setColleges(data || []);
        } catch (error) {
            console.error("Error fetching colleges:", error);
        }
        setLoading(false);
    };

    const fetchCollegesSpecific = async () => {
        if (!validateInputsforCollgeBased()) return;
        setLoading(true);
        setShowNoDataMsg(true);
        let collegeBase = {
            collegeCode: collegeCode,
            category: category,
            category_gender_filter: typeValue,
            category_region_filter: quotaValue,
            collegeName: collegeName,
        }
        console.log('passing Values of fetchCollegesSpecific', collegeBase);

        try {
            let data = await getCollegeByCode(predictorType, collegeCode, collegeName, category, typeValue, quotaValue);
            setColleges(data || []);
        } catch (error) {
            console.error("Error fetching colleges:", error);
        }
        setLoading(false);

    }

    const updateStudentRank = async () => {
        if (predictor == "jee" ? userDetail?.jeeRank === null : userDetail?.mhtcetRank === null) {
            try {
                console.log("userpredictordata", predictor);
                if (predictor == "jee") {
                    let res = await addJEERank(UserId, mhtcetRank);
                    console.log("userdata", res);
                    if (res?.data) {
                        setUserDetail(res?.data);
                        setInitialWarning(false);
                    } else {
                        return;
                    }
                }
                else {
                    let res = await addCetRank(UserId, mhtcetRank);
                    console.log("userdata", res);
                    if (res?.data) {
                        setUserDetail(res?.data);
                        setInitialWarning(false);
                    } else {
                        return;
                    }
                }
            } catch (error) {
                console.error("Error fetching colleges:", error);
                setLoading(false);
            }
        }
    }

    const fetchCollegesByAI = async () => {
        if (!validateInputsForAiBased()) return;
        setLoading(true);

        setShowNoDataMsg(true);
        let aiObj = {
            rank: mhtcetRank,
            branches: branches.length > 0 ? branches : ["All"],
            category: category,
            category_gender_filter: typeValue,
            category_region_filter: quotaValue,
            city: city.length > 0 ? city : ["All"],
        }
        console.log('passing Values of ai', aiObj);
        try {
            let data = await getPredictedColleges(predictorType, mhtcetRank, aiObj.branches, category, aiObj.city, typeValue, quotaValue);
            setColleges(data || []);
        } catch (error) {
            console.error("Error fetching colleges:", error);
        } finally {
            setLoading(false);
        }
    }
    const showRankConfig = () => {
        setShowRankConfgModal(true);
    };

    const hideRankConfig = () => {
        setShowRankConfgModal(false);
    };
    const submitInitialWarning = () => {
        const messages = [];
        if (mhtcetRank === null ||
            mhtcetRank <= 0 ||
            !Number.isInteger(Number(mhtcetRank))) {
            messages.push('Please enter a valid rank.')
            setShowError(messages);
            setOpen(true);
            return
        }
        if (mhtcetRank === ConfirmMhtcetRank) {
            updateStudentRank();
            return
        } else {
            messages.push('Rank and Confirm Rank do not match. Please check and try again.')
            setShowError(messages);
            setOpen(true);           // show the Snackbar once
            return
        }
    };

    const hideInitialWarning = () => {
        setInitialWarning(false);
        setIsToggleOpen("percentileRange")
    };

    const handleIconClick = (collegeName) => {
        setClickedCollege(collegeName); // Set the clicked college name
    };

    const toggleGroupStyles = {
        float: 'right',
        display: 'inline-flex',
        borderRadius: '87px',
        borderColor: "black",
        padding: '5px',
        marginRight: '9px',
        marginBottom: '10px',
        backgroundColor: '#f2e7e7',
        boxShadow: 'inset 0 1px 2px 0 rgba(0, 0, 0, 0.1)'
    };


    const handleToggle = (event, newSubscription) => {
        if (newSubscription !== null) {
            setIsToggleOpen(newSubscription)  // === "completed");
        }
    };
    const handleReset = () => {
        setErrors({})
        setShowError([])
        setStartPercentile(0);
        setEndPercentile(0);
        setStartRank(0);
        setEndRank(0);
        setBranches([]);
        setCategory(predictorType == "jee" ? "JEE" : "All");
        setTypeValue("All");
        setQuotaValue("All");
        setCity([]);
        setColleges([]);

        setCollegeCode('');
        setCollegeName(null);
        setShowNoDataMsg(false);

    }
    useEffect(() => {
        handleReset();

    }, [isTggleOpen])

    const collegeOptions = collegesOptions?.map(({ code, name }) => ({
        value: code,
        label: name,
    }));

    useEffect(() => {
        if (showNoDataMsg) {
            const timer = setTimeout(() => {
                setShowNoDataMsg(false);
            }, 5000); // 5000 milliseconds = 5 seconds
            return () => clearTimeout(timer); // Cleanup on unmount or change
        }
    }, [showNoDataMsg]);


    let notFoundMsg = " No matching colleges found based on your inputs.";
    const handleLegendClick = () => {
        setShowLegendModel(true);
    }
    const handleLegendModalClose = () => {
        setShowLegendModel(false);
    }
    const Transition = React.forwardRef(function Transition(props, ref) {
        return <Grow direction="down" ref={ref} {...props} />;
    });
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
        setShowError([])
    };

    return (
        <div className="college-container">

            <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} md={12}>
                    <h5 className="notificationHead" style={{ color: '#012248' }}>
                        {/* <div style={{ textAlign: 'left' }}> */}
                        <button onClick={() => handleBack()} style={backButtonStyle}>
                            ← Back
                        </button>
                        {/* </div> */}
                        {t('collegePredictor')}
                        {
                            isMobile &&
                            <InfoCircleOutlined style={{ fontSize: 'x-large', margin: '12px 5px' }} onClick={() => handleLegendClick()} />
                        }
                    </h5>
                </Col>
                <Col xs={24} sm={12} md={12} style={{ display: 'flex' }}>
                    {/* <Tooltip
                        title={'Know more'}
                        color="blue"
                        trigger="click"
                    > */}
                    {/* <div className="info-icon"> */}
                    {
                        !isMobile &&
                        <InfoCircleOutlined style={{ fontSize: 'x-large', margin: '12px 5px' }} onClick={() => handleLegendClick()} />

                    }
                    {/* </div> */}
                    {/* </Tooltip> */}
                    <ToggleButtonGroup
                        value={isTggleOpen}
                        exclusive
                        onChange={handleToggle}
                        aria-label="Subscription Toggle"
                        style={toggleGroupStyles}
                    >
                        <ToggleButton
                            value="percentileRange"
                            disabled={loading === true}
                            aria-label="percentileRange"
                            style={
                                {
                                    fontSize: '13px',
                                    fontFamily: 'Poppins',
                                    borderRadius: isTggleOpen === 'percentileRange' ? '87px' : '0',
                                    padding: '8px 11px',
                                    textTransform: 'capitalize',
                                    border: 'none',
                                    backgroundColor: isTggleOpen === 'percentileRange' ? "#fff" : "transparent",
                                    color: isTggleOpen === 'percentileRange' ? "#012248" : "#a0a0a0",
                                    cursor: 'pointer',
                                    boxShadow: isTggleOpen === 'percentileRange' ? '0 2px 2px 0 rgba(0, 0, 0, 0.1)' : '',
                                    transition: 'background-color 0.3s ease, color 0.3s ease',
                                    '&:hover': {
                                        backgroundColor: theme.palette.heading.main,
                                        color: theme.palette.drawerBackground.main,
                                        transform: 'scale(1.05)',
                                    },
                                }
                            } >
                            {t('percentileRnge')}
                        </ToggleButton>
                        <ToggleButton
                            value="rankRange"
                            disabled={loading === true}
                            aria-label="rankRange"
                            style={
                                {
                                    fontSize: '13px',
                                    fontFamily: 'Poppins',
                                    borderRadius: isTggleOpen === 'rankRange' ? '87px' : '0',
                                    padding: '8px 11px',
                                    textTransform: 'capitalize',
                                    border: 'none',
                                    backgroundColor: isTggleOpen === 'rankRange' ? "#fff" : "transparent",
                                    color: isTggleOpen === 'rankRange' ? "#012248" : "#a0a0a0",
                                    cursor: 'pointer',
                                    boxShadow: isTggleOpen === 'rankRange' ? '0 2px 2px 0 rgba(0, 0, 0, 0.1)' : '',
                                    transition: 'background-color 0.3s ease, color 0.3s ease',
                                    '&:hover': {
                                        backgroundColor: theme.palette.heading.main,
                                        color: theme.palette.drawerBackground.main,
                                        transform: 'scale(1.05)',
                                    },
                                }
                            } >
                            {t('rankRnge')}
                        </ToggleButton>
                        <ToggleButton
                            value="collegeSpecific"
                            disabled={loading === true}
                            aria-label="collegeSpecific"
                            style={
                                {
                                    fontSize: '13px',
                                    fontFamily: 'Poppins',
                                    borderRadius: isTggleOpen === 'collegeSpecific' ? '87px' : '0',
                                    padding: '8px 11px',
                                    textTransform: 'capitalize',
                                    border: 'none',
                                    backgroundColor: isTggleOpen === 'collegeSpecific' ? "#fff" : "transparent",
                                    color: isTggleOpen === 'collegeSpecific' ? "#012248" : "#a0a0a0",
                                    cursor: 'pointer',
                                    boxShadow: isTggleOpen === 'collegeSpecific' ? '0 2px 2px 0 rgba(0, 0, 0, 0.1)' : '',
                                    transition: 'background-color 0.3s ease, color 0.3s ease',
                                    '&:hover': {
                                        backgroundColor: theme.palette.heading.main,
                                        color: theme.palette.drawerBackground.main,
                                        transform: 'scale(1.05)',
                                    },
                                }

                            } >
                            {t('collegeSpecRnge')}
                        </ToggleButton>
                        <ToggleButton
                            value="AIPredictor"
                            disabled={loading === true}
                            aria-label="AIPredictor"
                            style={
                                // toggleButtonStyles(isTggleOpen)
                                {
                                    fontSize: '13px',
                                    fontFamily: 'Poppins',
                                    borderRadius: isTggleOpen === 'AIPredictor' ? '87px' : '0',
                                    padding: '8px 11px',
                                    textTransform: 'capitalize',
                                    border: 'none',
                                    backgroundColor: isTggleOpen === 'AIPredictor' ? "#fff" : "transparent",
                                    color: isTggleOpen === 'AIPredictor' ? "#012248" : "#a0a0a0",
                                    cursor: 'pointer',
                                    boxShadow: isTggleOpen === 'AIPredictor' ? '0 2px 2px 0 rgba(0, 0, 0, 0.1)' : '',
                                    transition: 'background-color 0.3s ease, color 0.3s ease',
                                    '&:hover': {
                                        backgroundColor: theme.palette.heading.main,
                                        color: theme.palette.drawerBackground.main,
                                        transform: 'scale(1.05)',
                                    },
                                }
                            } >
                            {t('AIpredRnge')}
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Col>
            </Row>
            {/* Filters */}
            {/* percentile Range section */}
            {isTggleOpen === 'percentileRange' && <div className="rankRange">
                <div className="filter-section">
                    <Row gutter={[16, 16]}>
                        <Col xs={24} sm={12} md={4} className="cols-control">
                            <label className="control-lablels">{t('StartPercentile')}</label>
                            <input
                                style={{
                                    width: '100%', height: '60%', borderRadius: '5px',
                                    border: 'darkgray 1px solid',
                                    background: 'white'
                                }}
                                type="number"
                                value={startPercentile === 0 ? '' : startPercentile}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (value === '') {
                                        setStartPercentile(0);
                                    } else {
                                        const num = Number(value);
                                        if (num >= 0) {
                                            setStartPercentile(num);
                                        }
                                    }
                                }}
                                className={errors.startPercentile ? "error-input" : ""}
                            />
                            <br />
                            {errors.startPercentile && <small className="error-text">{errors.startPercentile}</small>}
                        </Col>
                        <Col xs={24} sm={12} md={4} className="cols-control">
                            <label className="control-lablels">{t('EndPercentile')}</label>
                            <input
                                style={{
                                    width: '100%', height: '60%', borderRadius: '5px',
                                    border: 'darkgray 1px solid',
                                    background: 'white'
                                }}
                                type="number" value={endPercentile == 0 ? '' : endPercentile}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (value === '') {
                                        setEndPercentile(0);
                                    } else {
                                        const num = Number(value);
                                        if (num >= 0) {
                                            setEndPercentile(num);
                                        }
                                    }
                                }}
                                className={errors.endPercentile ? "error-input" : ""}
                            />
                            <br />
                            {errors.endPercentile && <small className="error-text">{errors.endPercentile}</small>}
                        </Col>
                        <Col xs={24} sm={12} md={5}>
                            <label className="control-lablels">{t('Category')}</label>
                            <select
                                style={{
                                    width: '100%', height: '60%', borderRadius: '5px',
                                    border: 'darkgray 1px solid',
                                    background: 'white'
                                }}
                                value={category} onChange={(e) => setCategory(e.target.value)}>
                                {categoryOptions?.map((cat) => (
                                    <option key={cat} value={cat}>
                                        {cat}
                                    </option>
                                ))}
                            </select>
                        </Col>
                        <Col xs={24} sm={12} md={5}>
                            <label className="control-lablels">{t('Type')}</label>
                            <select
                                disabled={(category === "All" || predictor === "jee")}
                                style={{
                                    width: '100%', height: '60%', borderRadius: '5px',
                                    border: 'darkgray 1px solid',
                                    background: (category === "All" || predictor === "jee") ? "rgb(225, 227, 227)" : 'white'
                                }}
                                value={typeValue} onChange={(e) => setTypeValue(e.target.value)}>
                                {typeOptions.map((cat) => (
                                    <option key={cat?.code} value={cat?.code}>
                                        {cat?.name}
                                    </option>
                                ))}
                            </select>
                        </Col>
                        <Col xs={24} sm={12} md={6}>
                            <label className="control-lablels">{t('Quota')}</label>
                            <select
                                disabled={(category === "All" || predictor === "jee")}
                                style={{
                                    width: '100%', height: '60%', borderRadius: '5px',
                                    border: 'darkgray 1px solid',
                                    background: (category === "All" || predictor === "jee") ? "rgb(225, 227, 227)" : 'white'
                                }}
                                value={quotaValue} onChange={(e) => setQuotaValue(e.target.value)}>
                                {quotaOptions.map((cat) => (
                                    <option key={cat.code} value={cat.code}>
                                        {cat.name}
                                    </option>
                                ))}
                            </select>
                        </Col>
                    </Row>
                </div>
                {/*City and Branch Multi-Select  */}
                <div className="filter-section">
                    <Row gutter={[16, 16]}>
                        <Col xs={24} sm={6} md={8}>
                            <label className="control-lablels">{t('City')}<small>({t('Maxcities')})</small></label>
                            <Select
                                mode="multiple"
                                style={{ width: "100%" }}
                                value={city}
                                onChange={(selectedCities) => {
                                    setCity(selectedCities);
                                    if (selectedCities.length > 3) {
                                        setErrors({ ...errors, city: "You can select a maximum of 3 cities!" });
                                    } else {
                                        let updatedErrors = { ...errors };
                                        delete updatedErrors.city;
                                        setErrors(updatedErrors);
                                    }
                                }}
                                className={errors.city ? "error-input" : ""}
                                options={cityOptions.map((city) => ({ value: city, label: city }))}
                            />
                            {errors.city && <small className="error-textcity">{errors.city}</small>}
                        </Col>
                        <Col xs={24} sm={18} md={16}>
                            <label className="control-lablels">{t('Branches')}</label>
                            <Select
                                mode="multiple"
                                style={{ width: "100%" }}
                                // placeholder="Select branches"
                                value={branches}
                                onChange={setBranches}
                                options={branchOptions.map((branch) => ({ value: branch, label: branch }))}
                            />
                        </Col>
                    </Row>
                </div>
            </div>}
            {/* rankRange section */}

            {isTggleOpen === 'rankRange' && <div className="rankRange">
                <div className="filter-section">
                    <Row gutter={[16, 16]}>
                        <Col xs={24} sm={12} md={4} className="cols-control">
                            <label className="control-lablels">{t('StartRank')}</label>
                            <input
                                style={{
                                    width: '100%', height: '60%', borderRadius: '5px',
                                    border: 'darkgray 1px solid',
                                    background: 'white'
                                }}
                                type="number"
                                value={startRank === 0 ? '' : startRank}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (value === '') {
                                        setStartRank(0);
                                    } else {
                                        const num = Number(value);
                                        if (num >= 0) {
                                            setStartRank(num);
                                        }
                                    }
                                }}
                                className={errors.startRank ? "error-input" : ""}
                            />
                            <br />
                            {errors.startRank && <small className="error-text">{errors.startRank}</small>}
                        </Col>
                        <Col xs={24} sm={12} md={4} className="cols-control">
                            <label className="control-lablels">{t('EndRank')}</label>
                            <input
                                style={{
                                    width: '100%', height: '60%', borderRadius: '5px',
                                    border: 'darkgray 1px solid',
                                    background: 'white'
                                }}
                                type="number" value={endRank === 0 ? '' : endRank}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (value === '') {
                                        setEndRank(0);
                                    } else {
                                        const num = Number(value);
                                        if (num >= 0) {
                                            setEndRank(num);
                                        }
                                    }
                                }}
                                className={errors.endRank ? "error-input" : ""}
                            />
                            <br />
                            {errors.endRank && <small className="error-text">{errors.endRank}</small>}
                        </Col>
                        <Col xs={24} sm={12} md={5}>
                            <label className="control-lablels">{t('Category')}</label>
                            <select
                                style={{
                                    width: '100%', height: '60%', borderRadius: '5px',
                                    border: 'darkgray 1px solid',
                                    background: 'white'
                                }}
                                value={category} onChange={(e) => setCategory(e.target.value)}>
                                {categoryOptions.map((cat) => (
                                    <option key={cat} value={cat}>
                                        {cat}
                                    </option>
                                ))}
                            </select>
                        </Col>
                        <Col xs={24} sm={12} md={5}>
                            <label className="control-lablels">{t('Type')}</label>
                            <select
                                disabled={(category === "All" || predictor === "jee")}
                                style={{
                                    width: '100%', height: '60%', borderRadius: '5px',
                                    border: 'darkgray 1px solid',
                                    background: (category === "All" || predictor === "jee") ? "rgb(225, 227, 227)" : 'white'
                                }}
                                value={typeValue} onChange={(e) => setTypeValue(e.target.value)}>
                                {typeOptions.map((cat) => (
                                    <option key={cat?.code} value={cat?.code}>
                                        {cat?.name}
                                    </option>
                                ))}
                            </select>
                        </Col>
                        <Col xs={24} sm={12} md={6}>
                            <label className="control-lablels">{t('Quota')}</label>
                            <select
                                disabled={(category === "All" || predictor === "jee")}
                                style={{
                                    width: '100%', height: '60%', borderRadius: '5px',
                                    border: 'darkgray 1px solid',
                                    background: (category === "All" || predictor === "jee") ? "rgb(225, 227, 227)" : 'white'
                                }}
                                value={quotaValue} onChange={(e) => setQuotaValue(e.target.value)}>
                                {quotaOptions.map((cat) => (
                                    <option key={cat.code} value={cat.code}>
                                        {cat.name}
                                    </option>
                                ))}
                            </select>
                        </Col>
                    </Row>
                </div>
                {/* City and Branch Multi-Select  */}
                <div className="filter-section">
                    <Row gutter={[16, 16]}>
                        <Col xs={24} sm={6} md={8}>
                            <label className="control-lablels">{t('City')}<small>({t('Maxcities')})</small></label>
                            <Select
                                mode="multiple"
                                style={{ width: "100%" }}
                                value={city}
                                onChange={(selectedCities) => {
                                    setCity(selectedCities);
                                    if (selectedCities.length > 3) {
                                        setErrors({ ...errors, city: "You can select a maximum of 3 cities!" });
                                    } else {
                                        let updatedErrors = { ...errors };
                                        delete updatedErrors.city;
                                        setErrors(updatedErrors);
                                    }
                                }}
                                className={errors.city ? "error-input" : ""}
                                options={cityOptions.map((city) => ({ value: city, label: city }))}
                            />
                            {errors.city && <small className="error-textcity">{errors.city}</small>}
                        </Col>
                        <Col xs={24} sm={18} md={16}>
                            <label className="control-lablels">{t('Branches')}</label>
                            <Select
                                mode="multiple"
                                style={{ width: "100%" }}
                                // placeholder="Select branches"
                                value={branches}
                                onChange={setBranches}
                                options={branchOptions.map((branch) => ({ value: branch, label: branch }))}
                            />
                        </Col>
                    </Row>
                </div>
            </div>}

            {/* collegeSpec section */}
            {isTggleOpen === 'collegeSpecific' && <div className="collegespec">
                <div className="filter-section">
                    <Row gutter={[16, 16]}>
                        <Col xs={24} sm={12} md={4} className="cols-control">
                            <label className="control-lablels">{t('CollegeCode')}</label>
                            <input
                                style={{
                                    width: '100%', height: '55%', borderRadius: '5px',
                                    border: 'darkgray 1px solid',
                                    background: 'white'
                                }}
                                type="number"
                                value={collegeCode === null ? '' : collegeCode}
                                onChange={(e) => {
                                    const inputCode = e.target.value;
                                    setCollegeCode(inputCode);

                                    if (inputCode === '' || inputCode === 0) {
                                        setErrors(prev => ({ ...prev, collegeCode: '' }));
                                        return;
                                    }

                                    const selectedOption = collegeOptions.find(option => option.value === inputCode);
                                    setCollegeName(selectedOption?.label || null);
                                }}

                                className={errors.collegeCode ? "error-input" : ""}
                            />
                            <br />
                            {errors.collegeCode && <small className="error-text">{errors.collegeCode}</small>}
                        </Col>
                        <Col xs={24} sm={12} md={8} className="cols-control">
                            <label className="control-lablels">{t('CollegeName')}</label>
                            <Select
                                showSearch
                                style={{
                                    width: '100%',
                                    borderRadius: '5px',
                                    border: '1px solid darkgray',
                                }}
                                value={collegeName}
                                onChange={(value) => {
                                    const selectedOption = collegeOptions.find(option => option.value === value);
                                    setCollegeCode(value);
                                    setCollegeName(selectedOption?.label || null);
                                }}

                                filterOption={(input, option) =>
                                    option.label.toLowerCase().includes(input.toLowerCase())
                                }
                                options={collegeOptions}
                                className={errors.collegeName ? "error-input" : ""}
                            />
                            <br />
                            {errors.collegeName && <small className="error-text">{errors.collegeName}</small>}

                        </Col>
                        <Col xs={24} sm={12} md={4}>
                            <label className="control-lablels">{t('CategoryReq')}</label>
                            <Select
                                style={{
                                    width: '100%',
                                    borderRadius: '5px',
                                    border: '1px solid darkgray',
                                    background: 'white',
                                    textAlign: 'left'
                                }}
                                value={category === "All" ? "" : category}
                                onChange={setCategory}
                                options={
                                    categoryOptions
                                        .filter(cat => (cat !== "All"))
                                        .map(cat => ({ value: cat, label: cat }))
                                }

                            />
                            <br />
                            {errors?.category && <small className="error-text">{errors?.category}</small>}
                        </Col>
                        <Col xs={24} sm={12} md={4}>
                            <label className="control-lablels">{t('Type')}</label>
                            <select
                                disabled={(category === "All" || predictor === "jee")}
                                style={{
                                    width: '100%', height: '54%', borderRadius: '5px',
                                    border: 'darkgray 1px solid',
                                    background: (category === "All" || predictor === "jee") ? "rgb(225, 227, 227)" : 'white'
                                }}
                                value={typeValue} onChange={(e) => setTypeValue(e.target.value)}>
                                {typeOptions.map((cat) => (
                                    <option key={cat?.code} value={cat?.code}>
                                        {cat?.name}
                                    </option>
                                ))}
                            </select>
                        </Col>
                        <Col xs={24} sm={12} md={4}>
                            <label className="control-lablels">{t('Quota')}</label>
                            <select
                                disabled={(category === "All" || predictor === "jee")}
                                style={{
                                    width: '100%', height: '54%', borderRadius: '5px',
                                    border: 'darkgray 1px solid',
                                    background: (category === "All" || predictor === "jee") ? "rgb(225, 227, 227)" : 'white'
                                }}
                                value={quotaValue} onChange={(e) => setQuotaValue(e.target.value)}>
                                {quotaOptions.map((cat) => (
                                    <option key={cat.code} value={cat.code}>
                                        {cat.name}
                                    </option>
                                ))}
                            </select>
                        </Col>
                    </Row>
                </div>
            </div>}

            {/* AIppredictor section */}

            {isTggleOpen === 'AIPredictor' && <div className="aipredictor">
                <div className="filter-section">
                    {/* <Row gutter={[16, 16]}> {userDetail.mhtcetRank == null && <h5>Please note that the MHTCET rank can only be configured once and cannot be change later.</h5>}</Row> */}

                    <Row gutter={[16, 16]}>
                        <Col xs={24} sm={12} md={4} className="cols-control">
                            <label className="control-lablels">{t('Rank')}</label>
                            <input
                                style={{
                                    width: '100%', height: '54%', borderRadius: '5px',
                                    border: 'darkgray 1px solid',
                                    //background: 'rgb(225, 227, 227)'
                                    background: (predictor == "jee" ? userDetail.jeeRank === null : userDetail.mhtcetRank === null) ? 'white' : 'rgb(225, 227, 227)'
                                }}
                                disabled={predictor == "jee" ? (userDetail?.jeeRank !== null) : (userDetail?.mhtcetRank !== null)}
                                type="number" value={mhtcetRank} //onChange={(e) => setStartRank(Number(e.target.value))}
                                className={errors.mhtcetRank ? "error-input" : ""}
                                // onChange={(e) => setMhtcetRank(Number(e.target.value))}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setMhtcetRank(value === "" ? "" : Number(value));
                                }}
                            />
                            <br />
                            {errors.mhtcetRank && <small className="error-text">{errors.mhtcetRank}</small>}
                        </Col>
                        <Col xs={24} sm={12} md={4}>
                            <label className="control-lablels">{t('Category')}</label>
                            <select
                                style={{
                                    width: '100%', height: '54%', borderRadius: '5px',
                                    border: 'darkgray 1px solid',
                                    background: 'white'
                                }}
                                value={category} onChange={(e) => setCategory(e.target.value)}>
                                {categoryOptions.map((cat) => (
                                    <option key={cat} value={cat}>
                                        {cat}
                                    </option>
                                ))}
                            </select>
                        </Col>
                        <Col xs={24} sm={12} md={4}>
                            <label className="control-lablels">{t('Type')}</label>
                            <select
                                disabled={(category === "All" || predictor === "jee")}
                                style={{
                                    width: '100%', height: '54%', borderRadius: '5px',
                                    border: 'darkgray 1px solid',
                                    background: (category === "All" || predictor === "jee") ? "rgb(225, 227, 227)" : 'white'
                                }}
                                value={typeValue} onChange={(e) => setTypeValue(e.target.value)}>
                                {typeOptions.map((cat) => (
                                    <option key={cat?.code} value={cat?.code}>
                                        {cat?.name}
                                    </option>
                                ))}
                            </select>
                        </Col>
                        <Col xs={24} sm={12} md={4}>
                            <label className="control-lablels">{t('Quota')}</label>
                            <select
                                disabled={(category === "All" || predictor === "jee")}
                                style={{
                                    width: '100%', height: '54%', borderRadius: '5px',
                                    border: 'darkgray 1px solid',
                                    background: (category === "All" || predictor === "jee") ? "rgb(225, 227, 227)" : 'white'
                                }}
                                value={quotaValue} onChange={(e) => setQuotaValue(e.target.value)}>
                                {quotaOptions.map((cat) => (
                                    <option key={cat?.code} value={cat?.code}>
                                        {cat?.name}
                                    </option>
                                ))}
                            </select>
                        </Col>
                        <Col xs={24} sm={6} md={8}>
                            <label className="control-lablels">{t('City')}<small>({t('Maxcities')})</small></label>
                            <Select
                                mode="multiple"
                                style={{ width: "100%" }}
                                // placeholder="Select cities"
                                value={city}
                                onChange={(selectedCities) => {
                                    setCity(selectedCities);
                                    if (selectedCities.length > 3) {
                                        setErrors({ ...errors, city: "You can select a maximum of 3 cities!" });
                                    } else {
                                        let updatedErrors = { ...errors };
                                        delete updatedErrors.city;
                                        setErrors(updatedErrors);
                                    }
                                }}
                                className={errors.city ? "error-input" : ""}
                                options={cityOptions.map((city) => ({ value: city, label: city }))}
                            />
                            {errors.city && <small className="error-textcity">{errors.city}</small>}
                        </Col>
                    </Row>
                </div>
                {/* Branch Multi-Select  */}

                <div className="filter-section">
                    <Row gutter={[16, 16]}>
                        <Col xs={24} sm={24} md={24}>
                            <label className="control-lablels">{t('Branches')}</label>
                            <Select
                                mode="multiple"
                                style={{ width: "100%" }}
                                value={branches}
                                onChange={setBranches}
                                options={branchOptions.map((branch) => ({ value: branch, label: branch }))}
                            />
                        </Col>
                    </Row>
                </div>
            </div>
            }

            {/* Buttons */}
            <div className="button-section">
                <Row gutter={[8, 8]}>
                    <Col xs={24} sm={12} md={12}></Col>
                    <Col xs={24} sm={12} md={6}>
                        <button
                            className="reset-btn"
                            onClick={() => handleReset()}
                        // disabled={isTggleOpen === 'AIPredictor'}
                        >
                            {t("resetBtn")}
                        </button>
                    </Col>
                    <Col xs={24} sm={12} md={6}>
                        <button className="find-btn" onClick={isTggleOpen === 'percentileRange' ? fetchCollegesByPercentile : (isTggleOpen === 'rankRange' ? fetchColleges : (isTggleOpen === 'collegeSpecific' ? fetchCollegesSpecific : ((predictor == "jee" ? userDetail?.jeeRank === null : userDetail?.mhtcetRank === null) ? showRankConfig : fetchCollegesByAI)))} disabled={loading}>
                            {loading ? (t("loading")) : t("findBtn")}
                        </button>
                    </Col>
                </Row>
            </div>

            {/* Results Table */}
            {/* Results Table */}
            {colleges.length > 0 ? (
                <div className="table-container">
                    <Row gutter={[8, 8]}>
                        {colleges.map((college, index) => (
                            <Tooltip
                                title={college.College}
                                color="blue"
                                trigger="click"
                            >
                                <Col key={index} xs={24} sm={12} md={12}>
                                    <Card style={{ backgroundColor: '#ffff' }} className='card'>
                                        <div className='floatingHeadWait'>
                                            <div>{college.Category}</div>
                                            <div>{college["Highest Rank"]}</div>
                                            <div className="percentileText">
                                                {`${parseFloat(college["Highest Percentile"]).toFixed(2)}`}
                                            </div>

                                        </div>
                                        <div>
                                            <h4 className='notificationTextTitle'>
                                                {`${college?.AbbreviatedName || college?.College} (${college["College Code"]})`}
                                                {/* <Tooltip
                                                title={college.College}
                                                color="blue"
                                                trigger="click"
                                            >
                                                <div className="info-icon">
                                                    <InfoCircleOutlined />
                                                </div>
                                            </Tooltip> */}
                                            </h4>
                                            <h5 className="notificationText">
                                                {college.Branch}{` (${college["Branch Code"]})`}&nbsp;
                                            </h5>
                                            <h5 className="notificationText" style={{ marginTop: 5 }}>
                                                {`Overall Seats: ${college["SI"]} ${college["Seats Cap1"] != null ? ` / ${college["Seats Cap1"]}` : ""}`}&nbsp;
                                            </h5>
                                        </div>

                                    </Card>
                                </Col>
                            </Tooltip>
                        ))}
                    </Row>
                </div>
            ) :
                ""
            }
            {

                isTggleOpen === 'percentileRange' && colleges.length <= 0 && showNoDataMsg && startPercentile >= 0 && endPercentile >= 0 ?
                    (
                        !loading && showNoDataMsg && colleges.length === 0 && (
                            <div className="no-data-msg" style={{ textAlign: 'center', marginTop: 20, fontFamily: "poppins", fontSize: "22px" }}>
                                {notFoundMsg}
                            </div>
                        )
                    ) : ""
            }
            {

                isTggleOpen === 'rankRange' && colleges.length <= 0 && showNoDataMsg && startRank !== 0 && endRank !== 0 ?
                    (
                        !loading && showNoDataMsg && colleges.length === 0 && (
                            <div className="no-data-msg" style={{ textAlign: 'center', marginTop: 20, fontFamily: "poppins", fontSize: "22px" }}>
                                {notFoundMsg}
                            </div>
                        )
                    ) : ""
            }

            {

                isTggleOpen === 'collegeSpecific' && colleges.length <= 0 && showNoDataMsg && collegeName !== null ?
                    (
                        !loading && showNoDataMsg && colleges.length === 0 && (
                            <div className="no-data-msg" style={{ textAlign: 'center', marginTop: 20, fontFamily: "poppins", fontSize: "22px" }}>
                                {notFoundMsg}
                            </div>
                        )
                    ) : ""
            }

            {

                isTggleOpen === 'AIPredictor' && colleges.length <= 0 && showNoDataMsg && mhtcetRank !== 0 ?
                    (
                        !loading && showNoDataMsg && colleges.length === 0 && (
                            <div className="no-data-msg" style={{ textAlign: 'center', marginTop: 20, fontFamily: "poppins", fontSize: "22px" }}>
                                {notFoundMsg}
                            </div>
                        )

                    ) : ""
            }
            {
                initialWarning && (
                    <WarningCustomModal
                        modal={true}
                        setModal={submitInitialWarning}
                        content={
                            <div style={{ overflowX: 'hidden' }}>
                                <h5 style={{ textAlign: 'left', margin: 30 }}>{`Please enter your ${predictor == "jee" ? "JEE" : "MHT-CET"} rank to use the AI Predictor.`}</h5>
                                <Row gutter={[16, 16]}>
                                    <Col xs={24} sm={24} md={24} style={{ paddingInline: 30 }} className="cols-control">
                                        <label className="control-lablels">Rank *</label>
                                        <input
                                            style={{
                                                width: '100%', height: '54%', borderRadius: '5px',
                                                border: 'darkgray 1px solid',
                                                //background: 'rgb(225, 227, 227)'
                                                background: (predictor == "jee" ? userDetail.jeeRank === null : userDetail.mhtcetRank === null) ? 'white' : 'rgb(225, 227, 227)'
                                            }}
                                            disabled={predictor == "jee" ? (userDetail?.jeeRank !== null) : (userDetail?.mhtcetRank !== null)}
                                            type="number" value={mhtcetRank} //onChange={(e) => setStartRank(Number(e.target.value))}
                                            className={errors.mhtcetRank ? "error-input" : ""}
                                            // onChange={(e) => setMhtcetRank(Number(e.target.value))}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setMhtcetRank(value === "" ? "" : Number(value));
                                            }}
                                            placeholder={`Enter your ${predictor == "jee" ? "JEE" : "MHT-CET"} rank`}
                                        />
                                        <br />
                                        {errors.mhtcetRank && <small className="error-text">{errors.mhtcetRank}</small>}
                                    </Col>
                                    <Col xs={24} sm={24} md={24} style={{ paddingInline: 30 }} className="cols-control">
                                        <label className="control-lablels">Confirm Rank *</label>
                                        <input
                                            style={{
                                                width: '100%', height: '54%', borderRadius: '5px',
                                                border: 'darkgray 1px solid',
                                                //background: 'rgb(225, 227, 227)'
                                                // background: userDetail.ConfirmMhtcetRank === null ? 'white' : 'rgb(225, 227, 227)'
                                            }}
                                            // disabled={userDetail?.ConfirmMhtcetRank !== null}
                                            type="number"
                                            value={ConfirmMhtcetRank}
                                            className={errors.ConfirmMhtcetRank ? "error-input" : ""}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setConfirmMhtcetRank(value === "" ? "" : Number(value));
                                            }}
                                            placeholder={`Re-enter your ${predictor == "jee" ? "JEE" : "MHT-CET"} rank`}
                                        />
                                    </Col>
                                </Row>

                                <h5 style={{ textAlign: 'center', margin: 30, color: '#d97706' }}> {"⚠️ Note: This rank cannot be changed once submitted, so make sure it’s accurate."}</h5>
                            </div>
                        }
                        showOk={true}
                        okButtonMessage={'Submit'}
                        showCancel={true}
                        cancelButtonMessage={'Cancel'}
                        hideCloseButton={true}
                        onOkClick={submitInitialWarning}
                        onCancelClick={hideInitialWarning}
                        title={'One User One License'}
                        // maxWidth="lg"
                        fullWidth={false}
                        hideTitle={true}
                    />
                )
            }
            {
                showRankConfgModal && (<WarningCustomModal
                    modal={true}
                    setModal={hideRankConfig}
                    content={
                        <div>
                            <h3 style={{ textAlign: 'center', margin: 30 }}>{"Please confirm your rank. After clicking OK, it can't be edited."}</h3>
                        </div>
                    }
                    showOk={true}
                    okButtonMessage={'Ok'}
                    showCancel={true}
                    cancelButtonMessage={'Cancel'}
                    onOkClick={fetchCollegesByAI}
                    onCancelClick={hideRankConfig}
                    title={'Rank Lock-In Warning'}
                    // maxWidth="lg"
                    fullWidth={false}
                    hideTitle={true}
                />)
            }
            {
                showLegendModel && (
                    <Dialog
                        open={showLegendModel}
                        onClose={handleLegendModalClose}
                        TransitionComponent={Transition}
                        maxWidth="sm"
                        fullWidth
                        PaperProps={{
                            sx: {
                                minHeight: '70vh',
                            }
                        }}
                    >
                        {/* Optional Title */}
                        <DialogTitle sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            background: 'rgb(245, 246, 250)',
                            boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.05)'
                        }}>
                            <h4 style={{
                                color: '#001124',
                                fontFamily: 'Poppins',
                                lineHeight: '1.42857143',
                            }}>

                                {t('Legends')}
                            </h4>
                            {/* Close Button */}
                            <IconButton
                                aria-label="close"
                                onClick={handleLegendModalClose}
                                size="small"
                                sx={{
                                    color: '#001124',
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogTitle>

                        {/* Content */}
                        <DialogContent>
                            <LegendInfo />
                        </DialogContent>

                        {/* Actions */}
                        <DialogActions sx={{ justifyContent: 'center' }}>
                            {/* <Button onClick={handleLegendModalClose} sx={{
                                backgroundColor: 'rgb(0, 17, 36)',
                                boxShadow: 'rgba(25, 33, 61, 0.08) 0px 1px 4px 0px',
                                borderRadius: '10px',
                                // lineHeight: '1.38',
                                fontWeight: 'bold',
                                fontFamily: 'Poppins',
                                color: 'white',
                                padding: '12px 30px',
                                fontSize: '12px'
                            }}>
                                Ok
                            </Button> */}
                        </DialogActions>
                    </Dialog>
                )
            }
            <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "center" }} open={open} onClose={handleClose} autoHideDuration={5000}>
                <MuiAlert severity="error"
                    onClose={handleClose}
                    sx={{ fontSize: "15px", width: "100%", backgroundColor: '#ffdead', color: '#000' }}
                >
                    {showError.map((msg, i) => (
                        <p key={i} style={{ margin: 0 }}>
                            {msg}
                        </p>
                    ))}
                </MuiAlert>
            </Snackbar>
        </div>
    );
};

export default CollegePredictors;

const backButtonStyle = {
    marginRight: 5,
    padding: "5px 10px",
    fontSize: 12,
    cursor: "pointer",
    borderRadius: 5,
    border: '1px solid #012248',
    color: '#fff',
    backgroundColor: '#012248',
    fontFamily: "Poppins",
};